import { render, staticRenderFns } from "./TA10.vue?vue&type=template&id=f7b987b8"
import script from "./TA10.vue?vue&type=script&lang=js"
export * from "./TA10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports